import { createRouter, createWebHistory } from 'vue-router'

import MainLayout from '../layouts/MainLayout.vue'

import HomeView from '../views/HomeView.vue'
import LoginView from '../views/LoginView.vue'
import Reset from '../views/ResetPassword.vue'
import Forgot from '../views/ForgotPassword.vue'


import HumanRoutes from './human'
import MastersRoutes from './masters'
import OperationsRoutes from './operations'
import FinanceRoutes from './finance'
import ReservationRoutes from './reservation'
import PermitRoutes from './permits'


const routes = [
    {
        path: '/',
        name: 'LoginView',
        component: LoginView,
        meta: { layout: "Login" },
    },
    {
        path: '/reset',
        name: 'Reset',
        component: Reset,
        meta: { layout: "Reset" }
    },
    {
        path: '/forgot',
        name: 'Forgot',
        component: Forgot,
        meta: { layout: "Reset" }
    },
    {
        path: '/',
        component: MainLayout,
        children: [
            {
                path: '/dash',
                name: 'home',
                component: HomeView
            },

            ...HumanRoutes,
            ...MastersRoutes,
            ...OperationsRoutes,
            ...FinanceRoutes,
            ...ReservationRoutes,
            ...PermitRoutes


        ]
    },

]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

export default router
